import Model from '@/models/Model.js';
import QueryBuilder from '@/utilities/QueryBuilder.js';

export default class MessageAlert extends Model {
    static entity = 'alert-messages';

    static queryBuilder = new QueryBuilder(this.entity);

    static fields() {
        return {
            id: this.attr(null),
            type: this.attr(null),
            notifiable_type: this.attr(null),
            notifiable_id: this.attr(null),
            data: this.attr(null),
            read_at: this.attr(null),

            ...super.fields(),
        };
    }

    static async fetch(courseId, types = []) {
        return this.api().get(
            this.queryBuilder
                .raw({ location: 'dashboard' })
                .when(courseId, query => query.filter('course_id', courseId))
                .when(types.length > 0, query => query.filter('types', types))
                .toUrl()
        );
    }

    static fetchOne(slug) {
        const queryBuilder = new QueryBuilder(`${this.entity}/${slug}`);

        const url = queryBuilder.include(this.includes).toUrl();

        return this.api().get(url);
    }

    static markAsRead(model) {
        const endpoint = this.queryBuilder.toUrl();

        this.api().put(endpoint, model);
    }

    static dismiss(model) {
        this.api().put('/api/alert-dismiss-messages', model);
    }

    static insertFromNotification(notification) {
        const messageAlert = {
            id: notification.id,
            type: notification.type,
            notifiable_id: notification.assignment.user_id,
            notifiable_type: 'App\\Models\\User',
            data: {
                assignment: notification.assignment,
                location: notification.location,
            },
        };

        return MessageAlert.insert({ data: messageAlert });
    }
}
